module.exports = __webpack_public_path__ + "img/ring_y_e_1_null@2x.93f3081d.png";